export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type:'div', 
              attributes: { class: 'section section-full' },
              components: [
                {
                  type: 'containerMarketing1', 
                },
              ],
              styles: `
             .section{
               position:relative; 
               with:100vw; 
               padding: 75px 5%; 
             }
             .section.section-full{
              padding:0; 
             }
             *{
              font-family: Roboto, Arial, sans-serif;
            }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};